const HERO_IMAGE =
  'https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/NehruTrophyBoatRace2024.jpg/1280px-NehruTrophyBoatRace2024.jpg';

const GALLERY_IMAGES = {
  heats:
    'https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/NehruTrophyBoatRace2024.jpg/1280px-NehruTrophyBoatRace2024.jpg',
  alleppey:
    'https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Nehru_trophy_boat_race%2C_Alleppey_%289488357610%29.jpg/1280px-Nehru_trophy_boat_race%2C_Alleppey_%289488357610%29.jpg',
  aranmula:
    'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Kerala_boatrace.jpg/1280px-Kerala_boatrace.jpg',
};

const RELATED_GUIDES = [
  {
    slug: 'kerala-boat-race-live-stream-youtube-channels',
    title: 'Kerala Boat Race Live Stream: Free YouTube Channels',
    blurb: 'DD Malayalam, Asianet, Manorama, 24 News — every free NTBR stream link.',
  },
  {
    slug: 'nehru-trophy-2026-chundan-snake-boats-captains',
    title: '72nd Nehru Trophy 2026: 22 Chundan Boats, Clubs & Captains',
    blurb: '2026 snake-boat line-up, captain table, photos, and video highlights.',
  },
  {
    slug: 'thalavady-chundan-history-ntbr-cbl-2026',
    title: 'Thalavady Chundan: History, Victories & NTBR / CBL 2026',
    blurb: 'Horse-headed snake boat — Neerattupuram winner and 2026 NTBR entry.',
  },
  {
    slug: 'kerala-boat-race-nehru-trophy-ntbr-malayalam',
    title: 'കേരള വള്ളംകളി ഗൈഡ്: NTBR 2026 & നെഹ്‌റു ട്രോഫി ചരിത്രം (മലയാളം)',
    blurb: 'ഈ ലേഖനത്തിന്റെ മലയാളം പതിപ്പ്.',
  },
];

const REFERENCE_LINKS = [
  {
    label: 'Official Nehru Trophy Boat Race website',
    url: 'https://nehrutrophy.nic.in/',
  },
  {
    label: 'About NTBR — Nehru Trophy Boat Race Society',
    url: 'https://nehrutrophy.nic.in/pages-en-IN/about-ntbr.php',
  },
  {
    label: 'Online tickets for NTBR 2026',
    url: 'https://nehrutrophy.nic.in/pages-en-IN/online_ticket.php',
  },
  {
    label: 'Alappuzha District — Nehru Trophy Boat Race',
    url: 'https://alappuzha.nic.in/en/nehru-trophy-boat-race/',
  },
  {
    label: 'Kerala Tourism — boat races',
    url: 'https://www.keralatourism.org/event/boat-races/',
  },
];

/** Kerala Vallamkali & Nehru Trophy Boat Race (NTBR) 2026 preview and history */
export const KERALA_BOAT_RACE_NTBR_POST = {
  id: 'featured-kerala-boat-race-ntbr-2026',
  slug: 'kerala-boat-race-nehru-trophy-ntbr-history',
  title: 'Kerala Boat Race Guide: Vallamkali, the Upcoming NTBR 2026 & Nehru Trophy History',
  excerpt:
    'From centuries-old snake boats on Kerala’s backwaters to the 72nd Nehru Trophy Boat Race on 22 August 2026 at Punnamada Lake—history, race-day facts, and how NTBR became Kuttanad’s Olympics on water.',
  publishedAt: '2026-08-08T14:00:00.000Z',
  coverImageUrl: HERO_IMAGE,
  authorName: 'Daily Sports Life',
  clubName: 'Kerala Sports Desk',
  blogCategory: 'boat-races',
  locale: 'en',
  boatRaceTopic: 'guide',
  alternateSlug: 'kerala-boat-race-nehru-trophy-ntbr-malayalam',
  featured: true,
  component: 'WellnessGuideBlogArticle',
  theme: 'diet',
  relatedPostsTitle: 'More Kerala & sports stories',
  relatedPosts: RELATED_GUIDES,
  referenceLinks: REFERENCE_LINKS,
  sections: [
    {
      type: 'stats',
      ariaLabel: 'NTBR 2026 at a glance',
      items: [
        { value: '22 Aug 2026', label: '72nd Nehru Trophy Boat Race' },
        { value: 'Punnamada', label: 'Alappuzha, Kerala' },
        { value: '1.4 km', label: 'Main race course' },
        { value: '100–150', label: 'Oarsmen per snake boat' },
      ],
    },
    {
      type: 'panel',
      title: 'Why Kerala’s boat races still stop the state',
      paragraphs: [
        'Every monsoon, Kerala’s backwaters turn into a stadium without walls. Crowds line the banks of lakes and canals as **chundan vallams**—long, cobra-prowed snake boats—surge forward to the beat of drums and **vanchippattu** (boat songs). Locals call the tradition **vallamkali**: boat play that is equal parts sport, festival, and village identity.',
        'The biggest stage of the season is the **Nehru Trophy Boat Race (NTBR)** at **Punnamada Lake** in Alappuzha. For the villages of **Kuttanad**, a win here is celebrated for months. For visitors, it is often the single most unforgettable image of God’s Own Country—hundreds of oars flashing in unison while two lakh spectators roar from the shore.',
        'This guide covers the living tradition of Kerala boat racing, the history that gave NTBR its name, and what to know about the **upcoming 72nd edition on Saturday, 22 August 2026**.',
      ],
      chips: ['Vallamkali', 'NTBR 2026', 'Chundan Vallam', 'Alappuzha', 'Onam season'],
    },
    {
      type: 'imageGallery',
      title: 'Punnamada Lake in pictures',
      intro:
        'Real Nehru Trophy race-day scenes from Wikimedia Commons (CC BY-SA).',
      images: [
        {
          url: GALLERY_IMAGES.heats,
          alt: 'Nehru Trophy Boat Race 2024 — chundan heat',
          caption: 'Nehru Trophy Boat Race 2024, Punnamada — Varghesepunnamada / Wikimedia.',
        },
        {
          url: GALLERY_IMAGES.alleppey,
          alt: 'Nehru Trophy boat race, Alleppey',
          caption: 'Nehru Trophy vallamkali, Alleppey — Wikimedia Commons.',
        },
        {
          url: GALLERY_IMAGES.aranmula,
          alt: 'Kerala boat race — snake boats',
          caption: 'Chundan vallams on Kerala backwaters — Anoopkn / Wikimedia.',
        },
      ],
    },
    {
      type: 'panel',
      title: 'Vallamkali — Kerala’s Olympics on water',
      paragraphs: [
        '**Vallamkali** grew out of Kerala’s waterways long before it became a tourist spectacle. In the feudal centuries of central Travancore, long war canoes were built for speed through narrow channels. Over time those vessels became racing boats, and village rivalries replaced battlefield ones.',
        'Races peak during the **Onam** season (roughly July–September), when the monsoon has filled the lakes and the calendar fills with regattas. The season traditionally opens with the **Champakulam Moolam Boat Race**—one of the oldest continuous boat festivals—before attention shifts to the Nehru Trophy and other marquee events across Alappuzha, Kottayam, and nearby districts.',
        'What makes the sport unique is not only the boats. Entire communities train together, host mass feasts for oarsmen, and treat the village **chundan** almost like a deity. Hindus, Christians, and Muslims often share the same bank and the same kitchen in the weeks before race day—a living symbol of Kerala’s communal harmony on water.',
      ],
    },
    {
      type: 'table',
      title: 'Boats you will see on race day',
      intro:
        'NTBR and other major regattas feature more than one class. The snake boat final is the headline, but smaller categories keep the lake busy all day.',
      headers: ['Boat type', 'What it is', 'Typical crew', 'Role in the festival'],
      rows: [
        [
          'Chundan Vallam (snake boat)',
          '100–138 ft racing war canoe with a raised cobra-hood prow; built mainly of anjili (wild jack) wood',
          'About 100–150 (oarsmen, helmsmen, singers, rhythm keepers)',
          'Main NTBR event; village pride and Champions Boat League opener',
        ],
        [
          'Veppu Vallam',
          'Traditional support / cook boat class still raced as its own category',
          'Smaller crew than a chundan',
          'Early races and heats that warm up the crowd',
        ],
        [
          'Iruttukuthy / Odi Vallam',
          'Faster, lighter boats historically linked to escort and night travel',
          'Modest crew',
          'Separate competitive categories on the Punnamada programme',
        ],
        [
          'Churulan Vallam',
          'Curved, symmetrical smaller racing boat',
          'Roughly 30–40',
          'Local and supporting races across the season',
        ],
      ],
    },
    {
      type: 'panel',
      title: 'Inside a chundan vallam',
      paragraphs: [
        'A snake boat is an extreme design: extremely long, extremely narrow, and shallow enough for Kerala’s canals. Master carpenters (**moothashari**) still build them with traditional joinery so the hull can flex slightly in choppy water instead of cracking.',
        'On race day the crew moves as one organism. Helmsmen steer with long rudder-oars; singers set the cadence; paddlers lock into 100–120 strokes a minute when the race is at full pace. The prow rises like a serpent’s hood; the stern climbs high above the water. When several chundans line up on Punnamada, the lake looks like a living mural of Kerala history.',
      ],
      callout:
        'Traditionally each major boat belongs to a village or boat club. Touching the boat and boarding it still carry rituals of respect—barefoot approach, careful oiling of the hull, and months of dawn-and-dusk practice before the flag drops.',
    },
    {
      type: 'panel',
      title: 'History of the Nehru Trophy Boat Race',
      paragraphs: [
        'NTBR’s modern prestige begins in **1952**, when India’s first Prime Minister, **Jawaharlal Nehru**, visited Alappuzha. He travelled through waterlogged **Kuttanad**, and the people welcomed him with a grand procession of snake boats on Punnamada Lake.',
        'An impromptu race followed. **Nadubhagam Chundan** won. Overcome by the spectacle, Nehru stepped into the winning boat—forgetting formal security protocol for a moment—and rode with the oarsmen toward the jetty. Local accounts still describe him standing in the chundan as waves rolled against the hull and other snake boats accompanied the procession.',
        'On returning to Delhi in December 1952, Nehru donated a **silver trophy** shaped like a snake boat on a wooden stand. It was engraved with words that still define the event: a tribute to the winners of a boat race that is “a unique feature of community life in Travancore Cochin.” What began as the **Prime Minister’s Trophy** soon became known as the **Nehru Trophy Boat Race**.',
        'From that gift grew Kuttanad’s national water festival. Held for decades on the second Saturday of August (with the 2026 date fixed as **22 August**), NTBR has become the race every boat club wants on its résumé. The event was paused in **2020 and 2021** during the coronavirus pandemic, then returned as both a cultural carnival and the opening statement of Kerala’s professional-era boat racing calendar.',
      ],
      chips: ['1952', 'Nadubhagam Chundan', 'Silver trophy', 'Kuttanad', 'Punnamada Lake'],
    },
    {
      type: 'table',
      title: 'NTBR timeline — key moments',
      headers: ['Year / era', 'What happened'],
      rows: [
        [
          '13th–14th century (legend)',
          'War canoes that became today’s chundan vallams are commissioned in feudal central Kerala—speed and coordination as military craft.',
        ],
        [
          '~400 years of Champakulam',
          'Champakulam Moolam and other temple-linked races keep vallamkali alive as sacred and community sport.',
        ],
        [
          '1952',
          'Nehru visits Alappuzha; Nadubhagam Chundan wins the welcome race; the Prime Minister boards the boat.',
        ],
        [
          'Dec 1952',
          'Nehru sends the silver snake-boat trophy; the annual race takes his name.',
        ],
        [
          'Late 20th–21st century',
          'NTBR grows into a mass spectator event with lakhs on the banks, national TV coverage, and international visitors.',
        ],
        [
          '2020–2021',
          'Race cancelled during the COVID-19 pandemic.',
        ],
        [
          '2019 onward',
          'Champions Boat League partners broaden the professional season; NTBR remains the marquee opening leg.',
        ],
        [
          '22 Aug 2026',
          '72nd Nehru Trophy Boat Race scheduled at Punnamada Lake, Alappuzha.',
        ],
      ],
    },
    {
      type: 'panel',
      title: 'Upcoming: 72nd Nehru Trophy Boat Race (2026)',
      paragraphs: [
        'Mark the calendar: the **72nd Nehru Trophy Boat Race** is set for **Saturday, 22 August 2026**, on **Punnamada Lake, Alappuzha**. Organisers are the **Nehru Trophy Boat Race Society** with the **Alappuzha District Administration**. Online tickets are already listed on the official NTBR site.',
        'The main course runs about **1.4 km** on marked tracks. More than **20 snake boats** typically enter, alongside smaller boat categories. Expect a day that starts with processions, silk umbrellas, and formation displays before the heats build toward the chundan final.',
        'In 2026 the race also opens the **Champions Boat League (CBL)** season. Boat clubs across Kuttanad and central Travancore have already opened residential camps—morning and evening water sessions, trial runs in veppu and iruttukuthy classes, then full chundan practice once houseboats clear the race track in early August.',
        'The Kerala government has raised the winning team’s prize money to **₹25 lakh**, sharpening an already fierce rivalry among traditional powerhouses and newer club campaigns.',
      ],
      orderedList: [
        '**Date:** Saturday, 22 August 2026',
        '**Edition:** 72nd Nehru Trophy Boat Race',
        '**Venue:** Punnamada Lake, Alappuzha (Alleppey), Kerala',
        '**Distance:** ~1.4 km snake-boat course',
        '**Nearest rail:** Alappuzha Railway Station (~5 km)',
        '**Nearest major airport:** Cochin International (COK), about 85 km',
        '**Tickets:** Official booking via nehrutrophy.nic.in (categories range from general stands to premium galleries)',
      ],
      callout:
        'Race-day crowds can exceed two lakh people. Arrive early, carry water and sun protection, and follow local police and society advisories for parking and gallery access. Confirm final heat timings on the official NTBR website closer to 22 August.',
    },
    {
      type: 'panel',
      title: 'What race day feels like',
      paragraphs: [
        'Morning brings a water pageant: decorated boats, ceremonial processions, and the first roar of **chenda** drums. By afternoon the lake is a corridor of colour—club colours on oarsmen’s jerseys, silk parasols on the banks, cameras packed along every vantage point.',
        'When the finalists lock onto the starting line, the sound changes. Songs tighten into race cadence. Oars hit the water together. Spray flies silver in the monsoon light. For a few minutes Punnamada is pure speed and synchrony—the reason Nehru jumped into a boat seventy-four years ago, and the reason families still plan their August around one Saturday in Alappuzha.',
      ],
      list: [
        'Listen for vanchippattu—the songs that keep a hundred paddles in time.',
        'Watch the amarakkar (helmsmen) at the stern; tiny corrections decide finishes.',
        'Village celebrations after a win can last late into the night—food, fireworks, and processions.',
        'Television and streaming coverage (including CBL partners in recent seasons) bring the race to Malayalees worldwide.',
      ],
    },
    {
      type: 'panel',
      title: 'Other boat races on the Kerala calendar',
      paragraphs: [
        'NTBR is the headline, but the season is a circuit. If you are building a Kerala monsoon sports trip—or following from abroad—these names sit alongside the Nehru Trophy in local lore.',
      ],
      list: [
        '**Champakulam Moolam Boat Race** — often the traditional season opener on the Pampa; deep religious and historical roots.',
        '**Aranmula Uthrattathi Vallamkali** — more sacred pageant than pure sprint; snake boats honour the Parthasarathy temple tradition.',
        '**Payippad, Thazhathangadi, Kumarakom and other local regattas** — village and club races that feed talent into NTBR and CBL.',
        '**Presidents Trophy / other coastal events** — expand the map beyond Punnamada for travellers chasing multiple race weekends.',
      ],
    },
    {
      type: 'panel',
      title: 'Visitor tips for NTBR 2026',
      orderedList: [
        'Book Alappuzha stays early—race weekend fills hotels, homestays, and houseboats.',
        'Buy gallery tickets from the **official NTBR portal** or authorised counters; avoid last-minute roadside markups when possible.',
        'Combine race day with a quieter backwater morning the day before or after; the lake is calmer when the carnival packs up.',
        'If you follow Malayalee sports culture abroad (NAMSL soccer, Onam celebrations, club tournaments), NTBR is the ancestral water equivalent—same village pride, different playing surface.',
        'Respect the boats and the banks: this is competitive sport and living culture, not only a photo stop.',
      ],
      callout:
        'Details such as heat schedules, ticket categories, and club line-ups can change. Always cross-check the official Nehru Trophy Boat Race website and Alappuzha district updates before you travel.',
    },
  ],
};
